import { render, staticRenderFns } from "./phone.module.vue?vue&type=template&id=eb399396&scoped=true"
import script from "./phone.module.vue?vue&type=script&lang=js"
export * from "./phone.module.vue?vue&type=script&lang=js"
import style0 from "./phone.module.vue?vue&type=style&index=0&id=eb399396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb399396",
  null
  
)

export default component.exports